import React from "react";
import { makeStyles } from "@material-ui/core";
var useStyles = makeStyles({
    root: {
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",
        textDecoration: "underline",
        display: "inline",
        margin: "0",
        padding: "0",
        font: "inherit",
        "&:hover": {
            textDecoration: "none"
        },
        "&:focus": {
            textDecoration: "none"
        }
    }
});
/**
 * Link Button
 * Programmatic link without an anchor
 * Same as <a href="#"> but compliant with accessibility standards
 * @see https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/anchor-is-valid.md
 * @param children
 * @param onClick
 * @constructor
 */
export var LinkButton = function (_a) {
    var children = _a.children, onClick = _a.onClick;
    var classes = useStyles();
    return (React.createElement("button", { type: "button", className: classes.root, onClick: onClick }, children));
};
//# sourceMappingURL=LinkButton.js.map